import _Rate from './rate';
import withInstall from '../utils/withInstall';

import './style';

export * from './type';

export const Rate = withInstall(_Rate);

export default Rate;
